import React, {useEffect, useState} from "react";
import {Form, Input, Button, Modal, message, InputNumber} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import Api from "../api";

const {TextArea} = Input;

const trainingVideoFormFields = (record) => ({
    url: record?.url ?? '',
    title: record?.title ?? '',
    time: record?.time ?? 0,
    image: record?.image ?? '',
    description: record?.description ?? '',
});

const NewTrainingVideo = ({loadVideos, editVideoData, setEditVideo}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        if (editVideoData?.id) {
            setIsModalVisible(true);
        }
    }, [editVideoData]);

    useEffect(() => {
        if (!isModalVisible) {
            return;
        }
        if (editVideoData?.id) {
            form.setFieldsValue(trainingVideoFormFields(editVideoData));
        } else {
            form.resetFields();
        }
    }, [isModalVisible, editVideoData, form]);

    const showModal = () => {
        setEditVideo(null);
        form.resetFields();
        setIsModalVisible(true);
    };

    const onFinish = (values) => {
        const isEdit = Boolean(editVideoData?.id);
        const payload = trainingVideoFormFields(values);

        Api[isEdit ? 'put' : 'post'](
            "/admin/training-videos/videos" + (isEdit ? '/' + editVideoData.id : ''),
            payload
        ).then(() => {
            setIsModalVisible(false);
            setEditVideo(null);
            form.resetFields();
            loadVideos();
            return message.success(isEdit ? 'Video updated!' : 'Success! New video added!');
        }).catch(e => {
            return message.error(`${e.message}`);
        });
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setEditVideo(null);
        form.resetFields();
    };

    return (
        <>
            <Button className="add-translation-btn" type="primary" onClick={showModal}>
                <PlusOutlined/> Add new video
            </Button>

            <Modal title={editVideoData?.id ? "Edit Video" : "Add New Video"}
                   open={isModalVisible}
                   onCancel={handleCancel}
                   footer={null}
                   destroyOnClose={true}
            >
                <Form
                    form={form}
                    key={editVideoData?.id ?? 'new'}
                    name="add-training-video"
                    labelCol={{span: 8}}
                    wrapperCol={{span: 16}}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Video URL"
                        name="url"
                        rules={[{required: true, message: 'Please insert video URL'}]}>
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="Title"
                        name="title"
                        rules={[{required: true, message: 'Please insert video title'}]}>
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="Runtime"
                        name="time"
                        rules={[{required: true, message: 'Please insert video runtime'}]}>
                        <InputNumber style={{width: '100%'}}/>
                    </Form.Item>
                    <Form.Item
                        label="Video image URL"
                        name="image"
                        extra="YouTube embed links will get the image automatically (leave this blank)"
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="Description"
                        name="description"
                    >
                        <TextArea/>
                    </Form.Item>
                    <Form.Item wrapperCol={{offset: 8, span: 16}}>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default NewTrainingVideo;
